import axios from "axios";
const endpoint = process.env.VUE_APP_BASE_API + "/api/master/peakPeriods";

export default {
  async getAll() {
    return await axios
      .get(endpoint + "/list")
      .then(response => {
        return response.data.data;
      })
      .catch(error => {
        throw error.response.data;
      });
  },
  async getAllByFilter(month, year, search) {
    return await axios
      .get(
        endpoint + `/list/filter?month=${month}&year=${year}&search=${search}`
      )
      .then(response => {
        return response.data.data;
      })
      .catch(error => {
        throw error.response.data;
      });
  },
  async getAllById(id) {
    return await axios
      .get(endpoint + `/list/${id}`)
      .then(response => {
        return response.data.data;
      })
      .catch(error => {
        throw error.response.data;
      });
  },
  async create(request) {
    return await axios
      .post(endpoint, request)
      .then(response => {
        return response.data;
      })
      .catch(error => {
        throw error.response.data;
      });
  },
  async update(request) {
    return await axios
      .put(endpoint, request)
      .then(response => {
        return response.data;
      })
      .catch(error => {
        throw error.response.data;
      });
  },
  async delete(id) {
    return await axios
      .delete(endpoint + `/${id}`)
      .then(response => {
        return response.data;
      })
      .catch(error => {
        throw error.response.data;
      });
  }
};



// WEBPACK FOOTER //
// ./src/services/master/peakPeriod/peakPeriodService.js